import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { uniq, map, find } from "lodash";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import { TypeSpecimenOutlined } from "@mui/icons-material";
import { Chip, Typography } from "@mui/material";
import { shuffle, getWords } from "../../../Js/Common";
//import useSound from "use-sound";
import Confirmation from "../../../Components/Modal/Confirmation";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import { calculateGenericScore } from "../../../Js/ScoreCalculate";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const audio = new Audio();
var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const BINGO = (props) => {
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // const [play] = useSound(require('../../../assets/audio/abcd.mp3'), {
  //   sprite: {
  //     A: [270, 690],
  //     B: [1098, 955],
  //     C: [2241, 1219],
  //     D: [3677, 1057],
  //     E: [5072, 901],
  //     F: [6216, 839],
  //     G: [7342, 1065],
  //     H: [8675, 902],
  //     I: [9870, 833],
  //     J: [10948, 983],
  //     K: [12193, 1040],
  //     L: [13450, 906],
  //     M: [14612, 1008],
  //     N: [15816, 932],
  //     O: [16952, 904],
  //     P: [18172, 856],
  //     Q: [19403, 1098],
  //     R: [20888, 821],
  //     S: [22043, 811],
  //     T: [23151, 979],
  //     U: [24478, 979],
  //     V: [25705, 1015],
  //     W: [26996, 964],
  //     X: [28218, 974],
  //     Y: [29450, 983],
  //     Z: [30784, 784],
  //   },
  // });

  // State
  let [userAnswer, setUserAnswer] = useState([]);
  let [logObj, setLogObj] = useState(initLogObj);
  let [shuffledltrs, setShuffledltrs] = useState([]);
  let [dropLetters, setDropLetters] = useState([]);
  let [wordsWithHints, setWordsWithHints] = useState([]);
  let [answer, setAnswer] = useState([]);
  let [visible, setVisible] = useState(false);
  let [correct, setCorrect] = useState(false);
  let [remainingAttempt, setRemainingAttempt] = useState(0);
  let [correctAns, setCorrectAns] = useState(0);
  let [showAnswer, setShowAnswer] = useState(false);

  const grid = 8;

  // Redux state
  const { attempted, currentAttempt, numberOfAttemptes, attempedAnsLog } =
    useSelector((state) => state.currentAsset);
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  useEffect(() => {
    const innerFun = async () => {
      if (props.content) {
        if (
          props.content.epage.options.content[0].dont_repeat_letters ||
          props.content.epage.options.content[0].dont_repeat_letters == "true"
        ) {
          setShuffledltrs(
            shuffle(
              uniq(
                props.content.epage.options.content[0].source_groups[0].letters
                  .toUpperCase()
                  .split("")
              )
            )
          );
        } else {
          setShuffledltrs(
            shuffle(
              props.content.epage.options.content[0].source_groups[0].letters
                .toUpperCase()
                .split("")
            )
          );
        }
        setDropLetters(
          new Array(
            +props.content.epage.options.content[0].number_of_letters
          ).fill("")
        );
        setRemainingAttempt(
          +props.content.epage.options.content[0].source_groups[0]
            .minimum_correct_answer
        );
        dispatch(
          currentAssetSliceActions.setBingoMin(
            +props.content.epage.options.content[0].source_groups[0]
              .minimum_correct_answer
          )
        );
        let wordsData = await getWords(
          map(
            props.content.epage.options.content[0].source_groups[0]
              .correct_words.from_wordly,
            "word"
          )
        );
        let ans = [];
        let withHint =
          props.content.epage.options.content[0].source_groups[0].correct_words.from_wordly.map(
            (val, index) => {
              let foundObj = find(wordsData.data, { uid: val.word });
              console.log("foundObj", foundObj);
              ans.push({
                word: foundObj.word_phrase.toUpperCase(),
                result: "correct",
                duration: 0,
              });
              return {
                ...val,
                word_phrase: foundObj.word_phrase.toUpperCase(),
              };
            }
          );
        setAnswer(ans);

        console.log("withHint", withHint);
        setWordsWithHints(withHint);
        let wordsOnly = map(wordsData.data, "word_phrase");
        wordsOnly = wordsOnly.join(",").toUpperCase().split(",");
        setUserAnswer([]);
        setCorrectAns(0);
        dispatch(currentAssetSliceActions.setCurrentAttemptData([]));
        // let actualAnswers = props.content.epage.options.content.map((val) => {
        //   if (val.answer) return JSON.parse(val.answer);
        //   else return JSON.parse("false");
        // });
        setLogObj({
          ...logObj,
          assetType: {
            ...logObj.assetType,
            value: props.content.info.asset_type_alias,
          },
          actualAnswer: wordsOnly,
        });
      }
    };
    innerFun();
  }, [props.content]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
      setCorrectAns(0);
      sessionStorage.removeItem("bingo_min");
    };
  }, []);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
  }, [logObj]);

  const dragPlay = (dragindex) => {
    //play({ id: shuffledltrs[dragindex] });
  };

  const allowDrop = (event) => {
    event.preventDefault();
  };

  const drop = (event, dropindex) => {
    event.preventDefault();
    var data = event.dataTransfer.getData("dragindex");
    if (data) {
      let letter = shuffledltrs[data];
      let arr1 = [...dropLetters];
      arr1.splice(dropindex, 1, letter);
      setDropLetters(arr1);
      console.log("data", dropindex);
      console.log("dragindex", data);
    }
    //event.target.appendChild(document.getElementById(data));
  };

  const removeLetter = (event, index) => {
    let arr2 = [...dropLetters];
    arr2.splice(index, 1, " ");
    setDropLetters(arr2);
  };

  const updateUserAnswer = (index) => {
    let obj = {
      word: dropLetters.join("").trim(),
    };

    if (!find(userAnswer, { word: obj.word })) {
      if (find(wordsWithHints, { word_phrase: obj.word })) {
        obj["result"] = "correct";
        setCorrectAns(correctAns + 1);
        setCorrect(true);
      } else {
        obj["result"] = "incorrect";
        setRemainingAttempt(remainingAttempt - 1);
        setCorrect(false);
      }
      let newArray = [...userAnswer, obj];
      setUserAnswer(newArray);
      if (
        find(wordsWithHints, { word_phrase: obj.word }) &&
        correctAns + 1 == wordsWithHints.length
      ) {
        dispatch(
          currentAssetSliceActions.setCurrentAttemptData({
            letters:
              props.content.epage.options.content[0].source_groups[0].letters,
            userans: newArray,
            actualAns: map(wordsWithHints, "word_phrase"),
            correctAns: correctAns + 1,
          })
        );
      } else {
        dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
      }
      setVisible(true);
    }
    setDropLetters(
      new Array(+props.content.epage.options.content[0].number_of_letters).fill(
        ""
      )
    );
  };

  const confirmAction = () => {
    if (correct) {
      //getScore(1, currentWord.word_phrase);
    }
    if (remainingAttempt == 0) {
      dispatch(
        currentAssetSliceActions.setCurrentAttemptData({
          letters:
            props.content.epage.options.content[0].source_groups[0].letters,
          userans: userAnswer,
          actualAns: map(wordsWithHints, "word_phrase"),
          correctAns: correctAns,
        })
      );
      setUserAnswer([...answer]);
      setShowAnswer(true);
    }
    setDropLetters(
      new Array(+props.content.epage.options.content[0].number_of_letters).fill(
        ""
      )
    );
    setVisible(false);
  };

  const getListStyle1 = (isDraggingOver) => ({
    display: "inline-flex",
    overflow: "auto",
    width: "auto",
  });

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 1,
    margin: `0px ${0}px 4px 8px`,
    // change background colour if dragging

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    display: "flex",
    overflow: "auto",
  });

  const move = (source, destination, droppableSource, droppableDestination) => {
    var sourceClone, destClone;

    if (droppableSource.droppableId == "droppable") {
      sourceClone = Array.from(source);
      destClone = Array.from(destination);
    } else {
      sourceClone = Array.from(destination);
      destClone = Array.from(source);
    }
    const removed = sourceClone[droppableSource.index];

    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    console.log("result", result);

    return result;
  };

  // a little function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result) => {
    console.log("res", result);
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }

    if (
      source.droppableId !== "droppable" &&
      destination.droppableId !== "droppable"
    ) {
      return;
    }

    let dropId = result.destination.droppableId.split("_");
    if (source.droppableId === destination.droppableId) {
      if (source.droppableId === "droppable") {
        const items = reorder(shuffledltrs, source.index, destination.index);
        setShuffledltrs(items);
      }
    } else {
      let result1, newDrop;
      console.log("Ssource.droppableId", source.droppableId);
      if (source.droppableId === "droppable") {
        if (dropLetters[dropId[0]].trim().length > 0) {
          return;
        }

        result1 = move(
          shuffledltrs,
          dropLetters[dropId[0]],
          source,
          destination
        );
        setShuffledltrs(result1["droppable"]);
        newDrop = result1[`${dropId[0]}_drop`];
        let innerArr = [...dropLetters];
        innerArr[dropId[0]] = newDrop[0];
        setDropLetters(innerArr);
      }
    }
  };

  return (
    <Grid
      container
       
      sx={{ height: "65vh", overflow: "auto", pr: 2, py: 2 }}
    >
      <DragDropContext
        onDragEnd={onDragEnd}
        onDragStart={(e) => {
          dragPlay(e.source.index);
        }}
      >
        <Grid item xs={7}>
          <Grid
            container
            sx={{ flexDirection: "row", justifyContent: "center", mt: 3 }}
          >
            {!attempedAnsLog && (
              <Grid sx={{ textAlign: "center", pb: 4 }}>
                <Typography
                  sx={{
                    color: "primary.main",
                    fontSize: "4vw",
                    fontWeight: "900",
                  }}
                >
                  {remainingAttempt}
                </Typography>
                <Typography
                  sx={{
                    color: "primary.main",
                    fontSize: "1.2rem",
                    fontWeight: "900",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4em",
                    },
                  }}
                >
                  Attempts Remaining
                </Typography>
              </Grid>
            )}
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <Grid
                  item
                  sx={{
                    ml: 1,
                    my: 1,
                    cursor: "pointer",
                    cursor: "pointer",
                  }}
                >
                  <Droppable droppableId="droppable" direction="horizontal">
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                        {...provided.droppableProps}
                        className={classes.scrollBarHeight}
                      >
                        {shuffledltrs &&
                          shuffledltrs.length > 0 &&
                          shuffledltrs.map((val, index1) => {
                            return (
                              <Draggable
                                key={`${index1}_drag`}
                                draggableId={`${index1}_drag`}
                                index={index1}
                              >
                                {(provided, snapshot) => (
                                  <Item
                                    sx={{
                                      lineHeight: 1,
                                      backgroundColor: "#e5ebff",
                                      color: "primary.main",
                                      fontWeight: "500",
                                      fontSize: "0.9rem",

                                      "@media (min-width: 1636px)": {
                                        fontSize: "1.6em",
                                        minWidth: "1.25rem",
                                        height: "1.45rem",
                                      },
                                    }}
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={getItemStyle(
                                      snapshot.isDragging,
                                      provided.draggableProps.style
                                    )}
                                  >
                                    {val}
                                  </Item>
                                )}
                              </Draggable>
                            );
                          })}
                      </div>
                    )}
                  </Droppable>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  justifyContent: "center",
                  mt: 5,
                }}
              >
                {dropLetters &&
                  !attempedAnsLog &&
                  remainingAttempt > 0 &&
                  correctAns < wordsWithHints.length &&
                  dropLetters.map((val, index) => {
                    return (
                      <Droppable
                        droppableId={`${index}_drop`}
                        direction="horizontal"
                        index={0}
                      >
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            style={getListStyle1(snapshot.isDraggingOver)}
                            {...provided.droppableProps}
                          >
                            <Grid item sx={{ ml: 1, cursor: "pointer", my: 1 }}>
                              <Item
                                sx={
                                  val.trim().length == 0
                                    ? {
                                        lineHeight: 1,
                                        width: "0.45rem",
                                        height: "0.65rem",
                                        border: 1,
                                        borderColor: "#D9D9D9",
                                        "@media (min-width: 1636px)": {
                                          minWidth: "1.25rem",
                                          height: "1.45rem",
                                        },
                                      }
                                    : {
                                        lineHeight: 1,
                                        backgroundColor: "#e5ebff",
                                        color: "primary.main",
                                        fontWeight: "500",
                                        fontSize: "0.9rem",
                                        "@media (min-width: 1636px)": {
                                          fontSize: "1.6rem",
                                          minWidth: "1.25rem",
                                          height: "1.45rem",
                                        },
                                      }
                                }
                                onDoubleClick={(event) =>
                                  removeLetter(event, index)
                                }
                              >
                                {val}
                              </Item>
                            </Grid>
                          </div>
                        )}
                      </Droppable>
                    );
                  })}
              </Grid>
            </Grid>
            {/* {showAnswer && (
            <Grid item xs={12}>
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-around",
                }}
              >
                <Grid item sx={{ ml: 1, cursor: "pointer" }}>
                  <Button
                    onClick={() => {
                      getScore(0, currentWord.word_phrase);
                      newWord();
                      setShowAnswer(false);
                    }}
                    variant="contained"
                    color="success"
                    fullWidth
                    sx={{
                      borderRadius: 10,
                      backgroundColor: "primary.success",
                      color: "#FFF",
                      fontWeight: "bold",
                      mt: 3,
                      px: 9,
                    }}
                  >
                    Next
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )} */}
            {dropLetters &&
              dropLetters.join("").trim().length > 0 &&
              remainingAttempt > 0 && (
                <Button
                  onClick={() => {
                    updateUserAnswer();
                  }}
                  variant="contained"
                  color="primary"
                  sx={{
                    borderRadius: 10,
                    backgroundColor: "primary",
                    color: "#FFF",
                    fontWeight: "bold",
                    mt: 5,
                    px: 9,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.2rem",
                    },
                  }}
                >
                  Submit
                </Button>
              )}
          </Grid>
        </Grid>
      </DragDropContext>
      <Grid
        item
        xs={5}
         
        sx={{
          height: "60vh",
          width: "100%",
          borderRadius: 5,
          backgroundColor: "#F5F7FF",
          alignItems: "flex-start",
          justifyContent: "left",
          display: "grid",
          px: 3,
          py: 2,
          "@media (min-width: 1636px)": {
            height: "62vh",
          },
          overflow: "auto",
        }}
      >
        {/* {typeof props.article == "object" &&
                props.article.map((val, index) => {
                  return ( */}
        {wordsWithHints &&
          wordsWithHints.map((hint, ind) => {
            return (
              <Typography
                sx={{
                  color: "primary.main",
                  fontWeight: "500",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.6rem",
                  },
                }}
              >
                <li style={{ listStyle: "none", wordBreak: "break-all" }}>
                  {ind + 1}. {hint["hints"][0]["hint"]}{" "}
                </li>

                {find(userAnswer, { word: hint["word_phrase"] }) && (
                  <Chip
                    label={`${hint["word_phrase"]}`}
                    color="primary"
                    sx={{ fontWeight: "700", fontSize: "1vw" }}
                  ></Chip>
                )}
              </Typography>
            );
          })}
      </Grid>
      <Confirmation
        visible={visible}
        primaryText={correct ? "Congratulations !" : "Incorrect"}
        image={correct ? "complete" : "error"}
        persistent={true}
        toggleModal={(flag) => setVisible(flag)}
        //timeout={3000}
        confirmText={
          correct ? "Next" : remainingAttempt == 0 ? "Show Answer" : "Try Again"
        }
        confirm={confirmAction}
        onClose={() => {
          setCorrect(false);
          // if (attempted && !correct) {
          //   checkShowAnswer();
          //   setAttempStatus(false);
          // }
        }}
        UX={true}
      ></Confirmation>
    </Grid>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
      textAlign: "left",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default BINGO;
